import { useAtom } from "jotai";
import { useI18N } from "common/hooks";
import { drawerMenuOpenAtom } from "@/store/atoms";
import { AuthModalScreen, useAuthModals } from "@/hooks/useAuthModals";
import { publicFaqUrl, publicAboutUrl, publicPrivacyUrl, publicTermsUrl, publicTaggingInformationUrl } from "common/config";
import { useGetInTouchModal } from "@/hooks/useGetInTouchModal";
import { useSelectedVenue } from "@/hooks/useSelectedVenue";
import { savedPlaceByUserIdToViewAtom, savedPlaceIdToViewAtom, venueDetailsOpenedAtom } from "@/state/atoms";
import { onboardingCompletedAtom } from "@/store/atoms";
import AnalyticsService from "@/services/analytics";

function GetNavigationPages(isLoggedIn, setIsModalOpen, setIsOnboardingModalOpen, setOnboardingCurrentScreen) {
  const i18n = useI18N();
  const { showModal } = useAuthModals();
  const { showGetInTouchModal } = useGetInTouchModal();

  const handleOpenFeedbackModal = () => {
    console.log("in handleOpenFeedbackModal");
    showGetInTouchModal();
  };

  const handleOpenAuthModal = () => {
    console.log("in handleOpenAuthModal");
    showModal(AuthModalScreen.EnterEmail);
  };

  const handleOpenOnboardingSliderModal = () => {
    console.log("in GNP handleOpenOnboardingSliderModal");
    setOnboardingCurrentScreen(0);
    setIsOnboardingModalOpen(true);
    setIsOnboardingCompleted(false);
  };

  const [, setDrawerMenuOpen] = useAtom(drawerMenuOpenAtom);

  const toggleDrawerMenu = () => {
    setDrawerMenuOpen((drawerMenuOpen) => !drawerMenuOpen);
  };


  const { setSelectedVenue } = useSelectedVenue();
  const [, setIsVenueDetailsOpen] = useAtom(venueDetailsOpenedAtom);
  const [, setSavedPlaceIdToView] = useAtom(savedPlaceIdToViewAtom);
  const [, setSavedPlaceByUserIdToView] = useAtom(savedPlaceByUserIdToViewAtom);
  const [, setIsOnboardingCompleted] = useAtom(onboardingCompletedAtom);

  const toggleDrawerMenuWithClear = () => {
    setSelectedVenue(null);
    setIsVenueDetailsOpen(false);

    setSavedPlaceIdToView("");
    setSavedPlaceByUserIdToView("");
  };


  return [
    {
      group: `${i18n.get("ProfileAndPreferences")}`,
      groupToShowForType: "loggedin",
      elements: [
        {
          name: `${i18n.get("yourProfile")}`,
          path: "/your-profile",
          icon: "/images/User_left_menu.svg",
          iconDark: "/images/User_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToProfileView");
            AnalyticsService.trackMx("navigatedToProfileView", {});            
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("yourActivity")}`,
          path: "/your-activity",
          icon: "/images/ChartLine_left_menu.svg",
          iconDark: "/images/ChartLine_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToProfileActivityView");
            AnalyticsService.trackMx("navigatedToProfileActivityView", {});            
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("yourAccessibilityProfile")}`,
          path: "/your-accessibility-profile",
          icon: "/images/WheelchairMotion_left_menu.svg",
          iconDark: "/images/WheelchairMotion_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToProfileAccessibilityView");
            AnalyticsService.trackMx("navigatedToProfileAccessibilityView", {});            
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("mySavedPlaces")}`,
          path: "/mysavedplaces",
          icon: "/images/Heart.svg",
          iconDark: "/images/Heart_white.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToMySavedPlaces");
            AnalyticsService.trackMx("navigatedToMySavedPlaces", {});            
            toggleDrawerMenuWithClear();
          },
        },
      ],
    },
    {
      group: `${i18n.get("helpSupport")}`,
      groupToShowForType: "both",
      elements: [
        // {
        //   name: `${i18n.get("howTheAppWorks")}`,
        //   path: "/content/how-it-works",
        //   icon: "/images/DeviceMobile.svg",
        //   iconDark: "/images/DeviceMobile_dark.svg",
        //   linkToShowForType: "both",
        //   publicUrl: "",
        //   onClick: () => {
        //     toggleDrawerMenu();
        //   },
        // },

        {
          name: `${i18n.get("howTheAppWorks")}`,
          path: "",
          icon: "/images/DeviceMobile.svg",
          iconDark: "/images/DeviceMobile_dark.svg",
          linkToShowForType: "both",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToOnboardingSlider");
            AnalyticsService.trackMx("navigatedToOnboardingSlider", {});            
            handleOpenOnboardingSliderModal();
            toggleDrawerMenu();
          },
        },

        {
          name: `${i18n.get("taggingInformation")}`,
          path: "/content/tagging-information",
          icon: "/images/Info.svg",
          iconDark: "/images/Info_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicTaggingInformationUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToExternalContentPage");
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("faqs")}`,
          path: "/content/faq",
          icon: "/images/Question.svg",
          iconDark: "/images/Question_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicFaqUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToExternalContentPage");
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("aboutSociability")}`,
          path: "/content/about",
          icon: "/images/UserCircle.svg",
          iconDark: "/images/UserCircle_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicAboutUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToExternalContentPage");
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("appFeedback")}`,
          path: "#",
          icon: "/images/ChatDots.svg",
          iconDark: "/images/ChatDots_dark.svg",
          linkToShowForType: "loggedin",
          publicUrl: "",
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToAppFeedback");
            AnalyticsService.trackMx("navigatedToAppFeedback", {});
            handleOpenFeedbackModal();
            toggleDrawerMenu();
          },
        },
      ],
    },
    {
      group: `${i18n.get("finePrint")}`,
      groupToShowForType: "both",
      elements: [
        {
          name: `${i18n.get("privacyPolicy")}`,
          path: "/content/privacy",
          icon: "/images/Shield.svg",
          iconDark: "/images/Shield_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicPrivacyUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToExternalContentPage");
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl
            });
            toggleDrawerMenu();
          },
        },
        {
          name: `${i18n.get("termsOfUse")}`,
          path: "/content/terms-conditions",
          icon: "/images/ClipboardText.svg",
          iconDark: "/images/ClipboardText_dark.svg",
          linkToShowForType: "both",
          publicUrl: publicTermsUrl,
          onClick: () => {
            AnalyticsService.trackGAEventHandler("navigatedToExternalContentPage");
            AnalyticsService.trackMx("navigatedToExternalContentPage", {
              publicUrl: publicTaggingInformationUrl
            });
            toggleDrawerMenu();
          },
        },
        {
          name: isLoggedIn ? `${i18n.get("logOut")}` : `${i18n.get("login")}`,
          path: isLoggedIn ? "" : "",
          icon: isLoggedIn
            ? "/images/SignOut_left_menu.svg"
            : "/images/SignOut_left_menu.svg",
          iconDark: isLoggedIn
            ? "/images/SignOut_dark.svg"
            : "/images/SignOut_dark.svg",
          linkToShowForType: isLoggedIn ? "loggedin" : "both",
          publicUrl: "",
          onClick: isLoggedIn
            ? () => {
              setIsModalOpen(true);
            }
            : () => {
              handleOpenAuthModal();
              toggleDrawerMenu();
            },
        },
      ],
    },
  ];
}

export default GetNavigationPages;
